import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('benefits_sets_export', '/benefits_sets_exports', 'export')
const reducer = generator.generate()

export default reducer
